
import Introduction from "./components/Introduction.vue"
import portCode from "./components/portCode.vue"
import portHistory from "./components/portHistory.vue"
import portExpect from "./components/portExpect.vue"

export default {
  components:{
    Introduction,
    portCode,
    portHistory,
    portExpect
  },
  data () {
    return {
    }
  }
}



// WEBPACK FOOTER //
// ./src/app.js